import { SelectField } from '@monorepo/shared/componentsV2/fields/SelectField';
import type { SelectOption } from '@monorepo/shared/componentsV2/Select/Select';
import { BooleanFormFieldOptions } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { type ConditionalFieldValueInputProps } from './ConditionalFieldValueFactory';

const StyledSelectField = styled(SelectField)`
  width: 11rem;
`;

const booleanFieldValues: BooleanFormFieldOptions = ['Yes', 'No'];

const booleanFieldOptions: SelectOption[] = booleanFieldValues.map((value) => ({
  label: value,
  value,
}));

export function ConditionalBoolField(
  inputFieldProps: ConditionalFieldValueInputProps['inputFieldProps'],
) {
  return (
    <StyledSelectField {...inputFieldProps} options={booleanFieldOptions} />
  );
}
